// extracted by mini-css-extract-plugin
export default {"rpgGameClanHunting":"RPGGameClanHunting_rpgGameClanHunting__8q5Ug"};